import i18n from '@casops/i18n';
import { ValueGetterFunc, ValueGetterParams } from 'ag-grid-community';
import { TriggerSource } from '@casops/store/apis/deviceMessagesApi';

// Convert the cell value from an enum to a translation (for searching/sorting).
export const deviceMessageSourceValueGetter = <TData extends { src: TriggerSource }>({
  data,
}: ValueGetterParams<TData, string>): ReturnType<ValueGetterFunc<TData, string>> => {
  return typeof data?.src === 'string' ? i18n.t(`DeviceMessageSource.${data.src}`) : null;
};
